import { ValidationErrorResponseSchema } from '@mntn/api-contracts/_shared/error-responses'
import { ErrorResponseSchema } from '@mntn/result'
import { initContract } from '@ts-rest/core'
import {
  PostEventBodySchema,
  PostEventMultiStatusResponseSchema,
  PostEventRequestSchema,
  PostEventResponseSchema,
} from './schemas.ts'

const c = initContract()

export const eventsContract = c.router(
  {
    publish: c.mutation({
      method: 'POST',
      path: '/seller/v1/events',
      description: 'Publish event',
      body: PostEventBodySchema,
      request: PostEventRequestSchema,
      responses: {
        200: PostEventResponseSchema,
        207: PostEventMultiStatusResponseSchema,
        403: ErrorResponseSchema,
        422: ErrorResponseSchema,
      },
    }),
  },
  {
    strictStatusCodes: true,
    commonResponses: {
      400: ValidationErrorResponseSchema,
    },
    metadata: { tags: ['Events'] },
  },
)

export type EventsContract = typeof eventsContract
